<template>
  <div class="pdl-skeleton w-full" :class="[computedClasses]">
    <template v-if="isList">
      <div
        v-for="(item, i) in list"
        :key="`item-${i}`"
        :style="heightWidth"
        :class="`${typeClass} ${typeClass}--items`"
      ></div>
    </template>
    <template v-else>
      <div :style="heightWidth" :class="typeClass"></div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PdlSkeleton',
  props: {
    /**
     * Sets the height of the skeleton container. Customize for different
     * scales like px, %, rem.
     */
    height: {
      type: String,
      default: undefined,
    },
    /**
     * Sets the width of the skeleton container. Customize for different scales
     * like px, %, rem.
     */
    width: {
      type: String,
      default: undefined,
    },
    /**
     * Set the template to use a list.
     */
    isList: {
      type: Boolean,
      default: false,
    },
    /**
     * Set the amount of list items.
     */
    listCount: {
      type: Number,
      default: 3,
    },
    /**
     * Sets or removes default bottom margin from skeleton wrapper.
     */
    hasWrapperMargin: {
      type: Boolean,
      default: true,
    },
    /**
     * Sets the different types of skeletons.
     */
    type: {
      type: String,
      default: 'text',
      validator: (type) => ['text', 'circle', 'square', 'image', 'heading'].includes(type),
    },
  },
  data() {
    return {
      types: {
        text: 'text',
        circle: 'circle',
        square: 'square',
        image: 'image',
        heading: 'heading',
      },
      list: Array(this.listCount),
    };
  },
  computed: {
    typeClass() {
      return `pdl-skeleton__${this.type}`;
    },
    computedClasses() {
      return {
        'flex flex-wrap': this.isList,
        'pdl-skeleton--no-margin': !this.hasWrapperMargin,
      };
    },
    heightWidth() {
      // Auto height, width when type is of square or circle
      if ([this.types.square, this.types.circle].some((geoShape) => this.type === geoShape)) {
        const width = this.width || this.height;
        return {
          width: `${width}`,
        };
      }
      return {
        height: `${this.height}`,
        width: `${this.width}`,
      };
    },
  },
};
</script>

<style lang="scss">
@import 'Skeleton.scss';
</style>
